export default "__VITE_ASSET__DyBt7Fwa__"